module.exports = __webpack_public_path__ + "static/media/trapezius_left_weak.046bc512.png";